import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { BookingPage } from './public/BookingPage';
import { Directory } from './public/Directory';
import { FindBooking, ManageBooking } from './public/ManageBooking';
import { Spinner } from './ui';

const AdminApp = lazy(() => import('./admin/AdminApp'));

function Loading() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '60vh', color: 'var(--muted)' }}>
      <Spinner />
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Directory />} />
          <Route path="/book/:slug" element={<BookingPage />} />
          <Route path="/booking/find" element={<FindBooking />} />
          <Route path="/booking/:reference" element={<ManageBooking />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<Directory notFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
